import type { RootState } from '@appStore/store'

import { createSelector } from '@reduxjs/toolkit'

import type { Persona } from '../model'

import { api } from '../api'

const FALLBACK: Persona[] = []
const selectPersonas = (state: RootState) => {
	const selector = api.endpoints.personas.select()

	return selector(state).data?.documents ?? FALLBACK
}

const selectHasInvited = createSelector(selectPersonas, personas =>
	personas.some(persona => persona.pending)
)

export { selectHasInvited, selectPersonas }
